import { renderTextLineClamp } from 'helpers';
import { OrdersListItem } from 'modules/order/orders/types';

export const renderEmployee = (item: OrdersListItem) =>
  renderTextLineClamp(item.employee?.name);
